import { TextField } from '@mui/material'
import { GRID_FORM_CONFIG_T } from '../../../../common/FormGenerator'
import { SOCIAL_ORDER_FOCUS_OPTIONS } from '../../../../consts/socialOrderFocus'
import { FocusCheckboxGroup } from '../../../../components/SocialOrder/FocusCheckboxGroup'
import { AvatarUpload } from '../../../../components/ui-kit/AvatarUpload'

export type DraftSocialOrderBlockName =
  | 'title'
  | 'description'
  | 'problem'
  | 'focus'
  | 'image'
  | 'completion_description'
  | 'completion_resource_url'

export const titleConfig: GRID_FORM_CONFIG_T<{ title: string }> = [
  [
    {
      id: 1,
      controllerName: 'title',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Название соцзаказа (до 240 символов)...',
        fullWidth: true,
        size: 'small',
        inputProps: { maxLength: 240 },
      }),
    },
  ],
]

export const descriptionConfig: GRID_FORM_CONFIG_T<{ description: string }> = [
  [
    {
      id: 2,
      controllerName: 'description',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Описание соцзаказа...',
        fullWidth: true,
        multiline: true,
        size: 'small',
        inputProps: { maxLength: 2000 },
      }),
    },
  ],
]

export const problemConfig: GRID_FORM_CONFIG_T<{ problem: string }> = [
  [
    {
      id: 4,
      controllerName: 'problem',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Какую проблему решает социальный заказ...',
        fullWidth: true,
        multiline: true,
        size: 'small',
        inputProps: { maxLength: 2000 },
      }),
    },
  ],
]

export const completionDescriptionConfig: GRID_FORM_CONFIG_T<{ completion_description: string }> = [
  [
    {
      id: 5,
      controllerName: 'completion_description',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Как выполнен социальный заказ...',
        fullWidth: true,
        multiline: true,
        size: 'small',
        inputProps: { maxLength: 4240 },
      }),
    },
  ],
]

export const completionResourceUrlConfig: GRID_FORM_CONFIG_T<{ completion_resource_url: string }> = [
  [
    {
      id: 6,
      controllerName: 'completion_resource_url',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'https://... ссылка на ресурс',
        fullWidth: true,
        size: 'small',
        inputProps: { maxLength: 2048 },
      }),
    },
  ],
]

export const imageConfig: GRID_FORM_CONFIG_T<{ image: string }> = [
  [
    {
      id: 0,
      controllerName: 'image',
      RenderElement: AvatarUpload,
      renderProps: () => ({
        hideRemove: true,
      }),
    },
  ],
]

export const focusConfig: GRID_FORM_CONFIG_T<{ focus: string[] }> = [
  [
    {
      id: 3,
      controllerName: 'focus',
      RenderElement: FocusCheckboxGroup,
      renderProps: () => ({
        options: SOCIAL_ORDER_FOCUS_OPTIONS,
      }),
    },
  ],
]

const formConfigs: Record<DraftSocialOrderBlockName, GRID_FORM_CONFIG_T<unknown>> = {
  image: imageConfig as GRID_FORM_CONFIG_T<unknown>,
  title: titleConfig as GRID_FORM_CONFIG_T<unknown>,
  description: descriptionConfig as GRID_FORM_CONFIG_T<unknown>,
  problem: problemConfig as GRID_FORM_CONFIG_T<unknown>,
  focus: focusConfig as GRID_FORM_CONFIG_T<unknown>,
  completion_description: completionDescriptionConfig as GRID_FORM_CONFIG_T<unknown>,
  completion_resource_url: completionResourceUrlConfig as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: DraftSocialOrderBlockName) => formConfigs[blockName]
